import React from 'react';
import { Redirect } from "react-router-dom";
import { 
    apiCreateDeck, apiEditDeck, apiGetDecks, apiGetPublicDecks, apiCopyDeck, apiAddNote, 
    apiResetDeck, apiSubscribeDeck, apiShareDeck, apiEmailResults, apiGetFlashCards, apiGetThisFlashCard, 
    apiRemoveShare, apiGetPremadeDecks, apiSendMessage, apiGetQuizzes, apiGetQuiz, apiGetLongQuizzes, 
    apiGetProgramQuizzes, apiSubmitQuiz, apiGetStoredYears,
    apiSyncCMETest
} from "../api";

import { 
    CREATE_DECK, CREATE_DECK_FAILED, EDIT_DECK, EDIT_DECK_FAILED, GET_DECKS, GET_DECKS_FAILED, 
    GET_PUBLIC_DECKS, GET_PUBLIC_DECKS_FAILED, COPY_DECKS, COPY_DECKS_FAILED, SHARE_DECKS, 
    SHARE_DECKS_FAILED, EMAIL_RESULTS, EMAIL_RESULTS_FAILED, GET_FLASH_CARDS, GET_FLASH_CARDS_FAILED, 
    GET_FLASH_CARD, GET_FLASH_CARD_FAILED, GET_PRE_MADE, ADD_NOTE_TO_DECK_FAILED, ADD_NOTE_TO_DECK,
    GET_PRE_MADE_FAILED, SEND_MESSAGE, SEND_MESSAGE_FAILED, GET_QUIZZES_DATA, GET_QUIZZES_DATA_FAILED,
    GET_QUIZ_DATA, GET_QUIZ_DATA_FAILED, GET_LONG_QUIZZES_DATA, GET_LONG_QUIZZES_DATA_FAILED,
    GET_PROGRAM_QUIZZES_DATA, GET_PROGRAM_QUIZZES_DATA_FAILED, SAVE_QUIZ_DATA, SAVE_QUIZ_DATA_ERROR,
    SAVE_TEST_DATA, SAVE_TEST_DATA_ERROR
} from "./types";
import { getLocalStorage, setLocalStorage } from '../common';

export const getPremadeDecks = (data) => async dispatch => {
    try {
        const response = await apiGetPremadeDecks(data);

        dispatch({
            type: GET_PRE_MADE,
            payload: response
        });
    } catch (e) {
        dispatch({
            type: GET_PRE_MADE_FAILED,
            payload: e
        });
    }
}

export const getQuizzes = (data) => async dispatch => {
    try {
        const response = await apiGetQuizzes(data);

        if (typeof response === 'string') {
            dispatch({
                type: GET_QUIZZES_DATA,
                payload: []
            });
        } 
        
        dispatch({
            type: GET_QUIZZES_DATA,
            payload: response
        });
    } catch (e) {
        dispatch({
            type: GET_QUIZZES_DATA_FAILED,
            payload: e
        });
    }
}

export const getStoredYears = (data) => async dispatch => {
    const years = JSON.parse(getLocalStorage(`sasp_my_cme_tests`));
    
    try {
        dispatch({
            type: SAVE_TEST_DATA,
            payload: years
        })
    } catch (e) {
        dispatch({
            type: SAVE_TEST_DATA_ERROR,
            payload: e
        });
    }
}

export const syncCMETest = (data) => async dispatch => {
    let years = JSON.parse(getLocalStorage(`sasp_my_cme_tests`));
    try {
        const response = await apiSyncCMETest(data);
        const prefix = `_${data.year}_${data.gamemode}`;

        let temp = JSON.parse(JSON.stringify(years[prefix]));

        temp[0].startindex = response.startindex;
        temp[0].percompleted = response.percentcomplete;

        for (var i = 0; i < response.selected.length; i++) {
            const r = response.selected[i];

            for (const t of temp[i].qoptions) {
                t.selected = 0;

                if (r.AnswerOptionID === t.AnswerOptionID) {
                    t.selected = 1;
                }
            }
        }

        years[prefix] = temp;

        await setLocalStorage('sasp_my_cme_tests', JSON.stringify(years));
        localStorage.setItem(`sasp_${prefix}`, Date.now());
        
        dispatch({
            type: SAVE_TEST_DATA,
            payload: temp
        })
    } catch (e) {
        dispatch({
            type: SAVE_TEST_DATA_ERROR,
            payload: e
        });
    }
}

export const getLongQuizzes = (data) => async dispatch => {
    try {
        const response = await apiGetLongQuizzes(data);

        if (typeof response === 'string') {
            dispatch({
                type: GET_LONG_QUIZZES_DATA,
                payload: []
            });
        }

        dispatch({
            type: GET_LONG_QUIZZES_DATA,
            payload: response
        });
    } catch (e) {
        dispatch({
            type: GET_LONG_QUIZZES_DATA_FAILED,
            payload: e
        });
    }
}

export const getProgramQuizzes = (data) => async dispatch => {
    try {
        const response = await apiGetProgramQuizzes(data);

        if (typeof response === 'string') {
            dispatch({
                type: GET_PROGRAM_QUIZZES_DATA,
                payload: []
            });
        }

        dispatch({
            type: GET_PROGRAM_QUIZZES_DATA,
            payload: response
        });
    } catch (e) {
        dispatch({
            type: GET_PROGRAM_QUIZZES_DATA_FAILED,
            payload: e
        });
    }
}

export const resetQuiz = () => async dispatch => {
    try {
        dispatch({
            type: GET_QUIZ_DATA,
            payload: []
        });
    } catch (e) {
        dispatch({
            type: GET_QUIZ_DATA_FAILED,
            payload: e
        });
    }
}

export const getQuiz = (data) => async dispatch => {
    try {
        const response = await apiGetQuiz(data);

        if (typeof response === 'string') {
            dispatch({
                type: GET_QUIZ_DATA,
                payload: []
            });
        }

        dispatch({
            type: GET_QUIZ_DATA,
            payload: response
        });
    } catch (e) {
        dispatch({
            type: GET_QUIZ_DATA_FAILED,
            payload: e
        });
    }
}

export const getFlashCards = (data) => async dispatch => {
    let results = {
        mcid: data.mcid,
        key: data.key
    }

    try {
        const response = await apiGetFlashCards(results);
        dispatch({
            type: GET_FLASH_CARDS,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_FLASH_CARDS_FAILED,
            payload: error
        });
    }
}

export const getThisFlashCard = (data) => async dispatch => {
    try {
        const response = await apiGetThisFlashCard(data);
        dispatch({
            type: GET_FLASH_CARD,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_FLASH_CARD_FAILED,
            payload: error
        });
    }
}

export const getDecks = (data) => async dispatch => {
    try {
        const response = await apiGetDecks(data);
        dispatch({
            type: GET_DECKS,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_DECKS_FAILED,
            payload: error
        });
    }
}

export const removeShareDeck = (data) => async dispatch => {
    try {
        const response = await apiRemoveShare(data);
        dispatch({
            type: GET_DECKS,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_DECKS_FAILED,
            payload: error
        });
    }
}

export const editDeck = (data) => async dispatch => {
    try {
        const response = await apiEditDeck(data);

        dispatch({
            type: EDIT_DECK,
            payload: response[0].decks
        });
    } catch (error) {
        dispatch({
            type: EDIT_DECK_FAILED,
            payload: error
        });
    }
}

export const createDeck = (data) => async dispatch => {
    try {
        const response = await apiCreateDeck(data);
        dispatch({
            type: GET_DECKS,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: CREATE_DECK_FAILED,
            payload: error
        });
    }
}

export const getPublicDecks = (data) => async dispatch => {
    try {
        const getPublicDeckResponse = await apiGetPublicDecks(data);
        dispatch({
            type: GET_PUBLIC_DECKS,
            payload: getPublicDeckResponse
        });
    } catch (error) {
        dispatch({
            type: GET_PUBLIC_DECKS_FAILED,
            payload: error
        });
    }
}

export const copyDeck = (data) => async dispatch => {
    try {
        const response = await apiCopyDeck(data);
       
        dispatch({
            type: COPY_DECKS,
            payload: response
        });

        // return <Redirect push to={{ pathname: "/editDeckScreen", deckID: response[0].NewDeckID }} />;
    } catch (error) {
        dispatch({
            type: COPY_DECKS_FAILED,
            payload: error
        });
    }
}

export const subscribeDeck = (data) => async dispatch => {
    try {
        const response = await apiSubscribeDeck(data);
        dispatch({
            type: GET_DECKS,
            payload: response
        });

        // return <Redirect push to={{ pathname: "/editDeckScreen", deckID: response[0].NewDeckID }} />;
    } catch (error) {
        dispatch({
            type: GET_DECKS_FAILED,
            payload: error
        });
    }
}

export const addNote = (data) => async dispatch => {
    try {
        const response = await apiAddNote(data);
        dispatch({
            type: ADD_NOTE_TO_DECK,
            payload: response
        });

        // return <Redirect push to={{ pathname: "/editDeckScreen" }} />;
    } catch (error) {
        dispatch({
            type: ADD_NOTE_TO_DECK_FAILED,
            payload: error
        });
    }
}

export const saveQuizData = (data) => async dispatch => {
    try { 
        const response = await apiSubmitQuiz(data);
        dispatch({
            type: SAVE_QUIZ_DATA,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: SAVE_QUIZ_DATA_ERROR,
            payload: error
        });
    }
}

export const resetDeck = (data) => async dispatch => {
    try { 
        const response = await apiResetDeck(data);

        dispatch({
            type: GET_DECKS,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_DECKS_FAILED,
            payload: error
        });
    }
}

export const shareDeck = (data) =>async dispatch => {
    try {
        const response = await apiShareDeck(data);
        dispatch({
            type: SHARE_DECKS,
            payload: response
        });

    } catch (e) {
        dispatch({
            type: SHARE_DECKS_FAILED,
            payload: e
        });
    }
}

export const emailResults = (data) =>async dispatch => {
    try {
        const response = await apiEmailResults(data);
        dispatch({
            type: EMAIL_RESULTS,
            payload: response
        });

    } catch (e) {
        dispatch({
            type: EMAIL_RESULTS_FAILED,
            payload: e
        });
    }
}

export const sendMessage = (data) =>async dispatch => {
    try {
        const response = await apiSendMessage(data);
        dispatch({
            type: SEND_MESSAGE,
            payload: response
        });

    } catch (e) {
        dispatch({
            type: EMAIL_RESULTS_FAILED,
            payload: e
        });
    }
}